 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","13":"stencil-ion-action-sheet-ios-entry-js","14":"stencil-ion-action-sheet-md-entry-js","15":"stencil-ion-alert-ios-entry-js","16":"stencil-ion-alert-md-entry-js","17":"stencil-ion-app_8-ios-entry-js","18":"stencil-ion-app_8-md-entry-js","19":"stencil-ion-avatar_3-ios-entry-js","20":"stencil-ion-avatar_3-md-entry-js","21":"stencil-ion-back-button-ios-entry-js","22":"stencil-ion-back-button-md-entry-js","23":"stencil-ion-backdrop-ios-entry-js","24":"stencil-ion-backdrop-md-entry-js","25":"stencil-ion-button_2-ios-entry-js","26":"stencil-ion-button_2-md-entry-js","27":"stencil-ion-card_5-ios-entry-js","28":"stencil-ion-card_5-md-entry-js","29":"stencil-ion-checkbox-ios-entry-js","30":"stencil-ion-checkbox-md-entry-js","31":"stencil-ion-chip-ios-entry-js","32":"stencil-ion-chip-md-entry-js","33":"stencil-ion-col_3-entry-js","34":"stencil-ion-datetime_3-ios-entry-js","35":"stencil-ion-datetime_3-md-entry-js","36":"stencil-ion-fab_3-ios-entry-js","37":"stencil-ion-fab_3-md-entry-js","38":"stencil-ion-img-entry-js","39":"stencil-ion-infinite-scroll_2-ios-entry-js","40":"stencil-ion-infinite-scroll_2-md-entry-js","41":"stencil-ion-input-ios-entry-js","42":"stencil-ion-input-md-entry-js","43":"stencil-ion-item-option_3-ios-entry-js","44":"stencil-ion-item-option_3-md-entry-js","45":"stencil-ion-item_8-ios-entry-js","46":"stencil-ion-item_8-md-entry-js","47":"stencil-ion-loading-ios-entry-js","48":"stencil-ion-loading-md-entry-js","49":"stencil-ion-menu_3-ios-entry-js","50":"stencil-ion-menu_3-md-entry-js","51":"stencil-ion-modal-ios-entry-js","52":"stencil-ion-modal-md-entry-js","53":"stencil-ion-nav_2-entry-js","54":"stencil-ion-popover-ios-entry-js","55":"stencil-ion-popover-md-entry-js","56":"stencil-ion-progress-bar-ios-entry-js","57":"stencil-ion-progress-bar-md-entry-js","58":"stencil-ion-radio_2-ios-entry-js","59":"stencil-ion-radio_2-md-entry-js","60":"stencil-ion-range-ios-entry-js","61":"stencil-ion-range-md-entry-js","62":"stencil-ion-refresher_2-ios-entry-js","63":"stencil-ion-refresher_2-md-entry-js","64":"stencil-ion-reorder_2-ios-entry-js","65":"stencil-ion-reorder_2-md-entry-js","66":"stencil-ion-ripple-effect-entry-js","67":"stencil-ion-route_4-entry-js","68":"stencil-ion-searchbar-ios-entry-js","69":"stencil-ion-searchbar-md-entry-js","70":"stencil-ion-segment_2-ios-entry-js","71":"stencil-ion-segment_2-md-entry-js","72":"stencil-ion-select_3-ios-entry-js","73":"stencil-ion-select_3-md-entry-js","74":"stencil-ion-slide_2-ios-entry-js","75":"stencil-ion-slide_2-md-entry-js","76":"stencil-ion-spinner-entry-js","77":"stencil-ion-split-pane-ios-entry-js","78":"stencil-ion-split-pane-md-entry-js","79":"stencil-ion-tab-bar_2-ios-entry-js","80":"stencil-ion-tab-bar_2-md-entry-js","81":"stencil-ion-tab_2-entry-js","82":"stencil-ion-text-entry-js","83":"stencil-ion-textarea-ios-entry-js","84":"stencil-ion-textarea-md-entry-js","85":"stencil-ion-toast-ios-entry-js","86":"stencil-ion-toast-md-entry-js","87":"stencil-ion-toggle-ios-entry-js","88":"stencil-ion-toggle-md-entry-js","89":"stencil-ion-virtual-scroll-entry-js","90":"stencil-polyfills-core-js","91":"stencil-polyfills-css-shim","92":"stencil-polyfills-dom"}[chunkId]||chunkId) + "-es2015." + {"0":"6b5b2c9ae25424766897","2":"a41f2752ab495f496744","3":"7c3f3afcd4151da2578e","4":"42e2613802ac7b3bcea6","5":"86ab14ea87842a6115a7","6":"169b983ac83c888a4c92","7":"1711adb044b070d25cdb","8":"43e0f59fb789d2f1bdde","9":"02bce917962076023066","13":"d53d1ece10efad058bcf","14":"af14ade73fec81b2dcbf","15":"0a064b1c1caa460c5480","16":"24677f3251f7019eda63","17":"4463c41beb7fb314b491","18":"150ccf26250cf5ac8d0d","19":"2b82506dfa48eaa5aa53","20":"cc7bf06d9f19a41c78a3","21":"2272a6872d54ffe7d9d4","22":"a26c8fc99c5d4aff1015","23":"a17e21501a9f9c3d28c7","24":"4414c7aad0fd21241868","25":"20337a7a2e9d802e567b","26":"43cec4652c8f6b365a0a","27":"b6e5f11e165a4033d72e","28":"c9b82b0fa9b96c85eec2","29":"cbfb03bb212107f84f18","30":"d03fb48f128e86d10b04","31":"3975729105569b071909","32":"545719ac1c25dea70eaf","33":"eb4d2e6d9ecc3fcfc190","34":"96059434c84ae7566906","35":"f94fc36757c32c7b2a09","36":"0bbb3fb36fbeb04dfe83","37":"c524ab6aa1b5444c2cd6","38":"3ebd84c12f42239b5a07","39":"d63af875f95b080ae08c","40":"ff0660390ce6e37a86b0","41":"79b74435ca0472ccabc8","42":"fa48770a3611acd0e98e","43":"f4ed4ea8add197e01819","44":"eb4a53cdb1daf1ab3987","45":"410d5b405371e4288a9c","46":"70871f90c13856530d92","47":"ba4082141209579fa4fe","48":"21e30ba22972f45ec7a6","49":"368223c6d2606931a039","50":"89355612bf7340114ccf","51":"7d2bb29740243c9dca5d","52":"0883c7459b0be06d4f21","53":"7131c255362a41bfbacb","54":"57d95804972f1a5e5049","55":"3dd5bf8e93fb41290d17","56":"97f77e26d8ce1ef3fe8c","57":"b6d046915f0f8e556a7f","58":"98651fcabbe7d12b3a28","59":"10be0758259ae8d7f726","60":"8d507bb89de4052dfdba","61":"d2d124decf134b78c3d1","62":"4913cb2ee9ebcdf3f421","63":"10106afbe27d4940f5c2","64":"35854f8b407fc9cb158c","65":"17a530dda3bc42409e26","66":"d74d76ba4a77fbd5c332","67":"103539803f5f195621d7","68":"94cbfb3cde02b7f21761","69":"246a8114e21d15f15ccc","70":"8c4a639be276c8e7cc52","71":"af52dac822ff82918a92","72":"e3855d7ecfbf997937b0","73":"5ce6c8a3f5827b236ff0","74":"dd933c874519a8dfc01f","75":"3821c6668be9d279ff07","76":"9638f408c3a110248417","77":"3547cfd04050732909a8","78":"d0e5d39cfee4d24b1427","79":"1420fbd0d39f15d9e0c6","80":"932f79f694351160a23c","81":"ebe9b919fe833551340c","82":"b8850a6c98862fadbe55","83":"4a8c8eec4ba9c0e344f0","84":"743b284a5b944104110f","85":"c88d79750f89d9b673d7","86":"244f098cee193a00355a","87":"fa55e1b271840255fc2e","88":"b703a717ed2fe05bdfb7","89":"d9dfe4d7cf88f3a04896","90":"cd93540faac994b15672","91":"93efe8bce73eb95e88c2","92":"ef6f0ff99a77b1e277c7","94":"2b3956f31dc1a1ce6ae7","95":"ed0591db631ab2be86f3","96":"e92ff8819483da2ddd8e","97":"e040a5d1098effbf07f3","98":"686f1c0408414de066d9","99":"819447b5c261ef10666a","100":"5c97fd701fd5ff39beb8","101":"795cd4e5b7ce6a61231d","102":"81130a8359f20983d755","103":"890a18a5e2c780eff56a","104":"aa02fda7f10ad42da04f","105":"0f9c4c2455320ea84236","106":"c2c7ef1f6583d78bbca4","107":"0c0b685b11cf65264c5c","108":"f16e53a3cb7720a7b3d1","109":"4f25d64536ce4ca89824","110":"0e53e5dc5bddfddb274a","111":"7168430b4b8de2a97043","112":"84a01cde511c52739843","113":"6f6bb44b61abf1d78a7d","114":"fde2f4b920b586e87a91","115":"2f13944b983969ff0500","116":"398f8aba38f16fd81896","117":"426f0b7ea6cb1dd613d4","118":"0a08127f1745a7a27909","119":"ebb1fc04716e53ce3c23","120":"531d3952a7b091d89f83"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
